import {Button, notification, Typography} from "antd";
import {useEffect, useState} from "react";
import ApiService from "../services/ApiService";
import {MessageCodes} from "../app-components/outputs/MessageCodes";
import {B1} from "../app-components/outputs/internal/B1";
import {B2} from "../app-components/outputs/internal/B2";
import {B3} from "../app-components/outputs/internal/B3";
import {B4} from "../app-components/outputs/internal/B4";
import {B5} from "../app-components/outputs/internal/B5";
import {B6} from "../app-components/outputs/internal/B6";
import {B7} from "../app-components/outputs/internal/B7";
import {B9} from "../app-components/outputs/internal/B9";
import {B10} from "../app-components/outputs/internal/B10";
import {B11} from "../app-components/outputs/internal/B11";
import {B12} from "../app-components/outputs/internal/B12";
import {B13} from "../app-components/outputs/internal/B13";
import {C1} from "../app-components/outputs/compare/C1";
import {C2} from "../app-components/outputs/compare/C2";
import {C3} from "../app-components/outputs/compare/C3";
import {C4} from "../app-components/outputs/compare/C4";
import {C5} from "../app-components/outputs/compare/C5";
import {C6} from "../app-components/outputs/compare/C6";
import {C7} from "../app-components/outputs/compare/C7";
import {C8} from "../app-components/outputs/compare/C8";
import {C9} from "../app-components/outputs/compare/C9";
import {C11} from "../app-components/outputs/compare/C11";
import {C12} from "../app-components/outputs/compare/C12";
import {C13} from "../app-components/outputs/compare/C13";
import {C20} from "../app-components/outputs/compare/C20";
import {C21} from "../app-components/outputs/compare/C21";
import {useUser} from "../context/UserContext";
import MockB1 from "../app-components/outputs/mock-data/MockB1";
import MockB2 from "../app-components/outputs/mock-data/MockB2";
import MockB3 from "../app-components/outputs/mock-data/MockB3";
import MockB4 from "../app-components/outputs/mock-data/MockB4";
import MockB5 from "../app-components/outputs/mock-data/MockB5";
import MockB6 from "../app-components/outputs/mock-data/MockB6";
import MockB7 from "../app-components/outputs/mock-data/MockB7";
import MockB9 from "../app-components/outputs/mock-data/MockB9";
import MockB10 from "../app-components/outputs/mock-data/MockB10";
import MockB11 from "../app-components/outputs/mock-data/MockB11";
import MockB12 from "../app-components/outputs/mock-data/MockB12";
import MockB13 from "../app-components/outputs/mock-data/MockB13";
import MockC1 from "../app-components/outputs/mock-data/MockC1";
import MockC2 from "../app-components/outputs/mock-data/MockC2";
import MockC3 from "../app-components/outputs/mock-data/MockC3";
import MockC4 from "../app-components/outputs/mock-data/MockC4";
import MockC5 from "../app-components/outputs/mock-data/MockC5";
import MockC6 from "../app-components/outputs/mock-data/MockC6";
import MockC7 from "../app-components/outputs/mock-data/MockC7";
import MockC8 from "../app-components/outputs/mock-data/MockC8";
import MockC9 from "../app-components/outputs/mock-data/MockC9";
import MockC11 from "../app-components/outputs/mock-data/MockC11";
import MockC12 from "../app-components/outputs/mock-data/MockC12";
import MockC13 from "../app-components/outputs/mock-data/MockC13";
import MockC20 from "../app-components/outputs/mock-data/MockC20";
import MockC21 from "../app-components/outputs/mock-data/MockC21";
import MockB17 from "../app-components/outputs/mock-data/MockB17";
import MockB20 from "../app-components/outputs/mock-data/MockB20";
import MockB26 from "../app-components/outputs/mock-data/MockB26";
import MockB30 from "../app-components/outputs/mock-data/MockB30";
import MockB15 from "../app-components/outputs/mock-data/MockB15";
import MockB21 from "../app-components/outputs/mock-data/MockB21";
import MockB14 from "../app-components/outputs/mock-data/MockB14";
import MockB16 from "../app-components/outputs/mock-data/MockB16";
import MockB24 from "../app-components/outputs/mock-data/MockB24";
import MockB22 from "../app-components/outputs/mock-data/MockB22";
import MockB25 from "../app-components/outputs/mock-data/MockB25";
import MockB27 from "../app-components/outputs/mock-data/MockB27";
import MockB28 from "../app-components/outputs/mock-data/MockB28";
import MockB29 from "../app-components/outputs/mock-data/MockB29";
import MockB18 from "../app-components/outputs/mock-data/MockB18";
import MockB31 from "../app-components/outputs/mock-data/MockB31";
import MockB38 from "../app-components/outputs/mock-data/MockB38";
import MockB40 from "../app-components/outputs/mock-data/MockB40";
import {CheckOperations, ComparisonOperations} from "../app-components/run-project/Operations";

export default function ErrorCodesHelp() {
    const [errors, setErrors] = useState([])
    const [errorCount, setErrorCount] = useState(0)
    const [misMessages, setMissMessages] = useState({
        keys: [],
        codes: []
    })
    const {user} = useUser()

    const createHelpMessages = () => {
        let errorCodeCount = 0
        const messages = [
            {key: 'B1',  data: MockB1 },
            {key: 'B2',  data: MockB2 },
            {key: 'B3',  data: MockB3 },
            {key: 'B4',  data: MockB4 },
            {key: 'B5',  data: MockB5 },
            {key: 'B6',  data: MockB6 },
            {key: 'B7',  data: MockB7 },
            {key: 'B9',  data: MockB9 },
            {key: 'B10', data: MockB10},
            {key: 'B11', data: MockB11},
            {key: 'B12', data: MockB12},
            {key: 'B13', data: MockB13},
            {key: 'B14', data: MockB14},
            {key: 'B15', data: MockB15},
            {key: 'B16', data: MockB16},
            {key: 'B17', data: MockB17},
            {key: 'B18', data: MockB18},
            {key: 'B20', data: MockB20},
            {key: 'B21', data: MockB21},
            {key: 'B22', data: MockB22},
            {key: 'B24', data: MockB24},
            {key: 'B25', data: MockB25},
            {key: 'B26', data: MockB26},
            {key: 'B27', data: MockB27},
            {key: 'B28', data: MockB28},
            {key: 'B29', data: MockB29},
            {key: 'B30', data: MockB30},
            {key: 'B31', data: MockB31},
            {key: 'B38', data: MockB38},
            {key: 'B40', data: MockB40},
            {key: 'C1',  data: MockC1 },
            {key: 'C2',  data: MockC2 },
            {key: 'C3',  data: MockC3 },
            {key: 'C4',  data: MockC4 },
            {key: 'C5',  data: MockC5 },
            {key: 'C6',  data: MockC6 },
            {key: 'C7',  data: MockC7 },
            {key: 'C8',  data: MockC8 },
            {key: 'C9',  data: MockC9 },
            {key: 'C11', data: MockC11},
            {key: 'C12', data: MockC12},
            {key: 'C13', data: MockC13},
            {key: 'C20', data: MockC20},
            {key: 'C21', data: MockC21},
            {key: 'C21', data: MockC21},
            {key: 'C21', data: MockC21},
            {key: 'C21', data: MockC21},
            {key: 'C21', data: MockC21},
            {key: 'C21', data: MockC21},
        ]

        const defined = []
        Object.keys(MessageCodes.Internal).forEach(x => {
            const msg = MessageCodes.Internal[x]
            defined.push(msg)
        })
        Object.keys(MessageCodes.Compare).forEach(x => {
            const msg = MessageCodes.Compare[x]
            defined.push(msg)
        })

        const missing = {
            keys: [],
            codes: []
        }

        defined.forEach(x => {
            const key = messages.find(m => x.key === m.key)
            if(!key)
            {
                missing.keys.push(x.key)
                return
            }

            key.data.forEach(c => {
                if(!defined.find(x => x.error_id === c.error_id))
                    missing.codes.push(c.error_id)
            })
        })

        let _outputs = []
        messages.forEach(m => {
            errorCodeCount += m.data.length
            let operation = {ui: {}}
            const all = [...CheckOperations, ...ComparisonOperations]
            all.forEach(op => {
                const child = op.children.find(x => x.key === m.key)
                if(child) {
                    operation = child
                }
            })

            const item = operation.ui
            if(operation) {
                const {Component} = item

                _outputs.push(
                    <>
                        <Typography.Title level={2}>
                            {m.key} - {defined.find(x => x.key === m.key)?.key_text}
                        </Typography.Title>
                        <Component
                            data={{result: m?.data}}
                            message_key={m.key}
                        />
                        <br/>
                    </>
                )
            }
        })

        setErrorCount(errorCodeCount)
        setErrors(_outputs)
        setMissMessages(missing)
    }

    useEffect(() => {
        createHelpMessages()
    }, [])

    return (
        <>
            <Typography.Title level={3}>
                Total Messages: {errorCount}
            </Typography.Title>
            <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                <Button
                    size={'small'}
                    type={'primary'}
                    onClick={async () => {
                        const reportHtml = document.getElementById('report-result')
                        const res = await ApiService.Report.DownloadPDF(`<html><head></head><body style="font-family: Calibri">${reportHtml.innerHTML}</body></html>`)

                        if(res.success) {
                            const base64data = res.data;
                            var a = document.createElement("a"); //Create <a>
                            a.href = 'data:application/text;base64,'+base64data; //Image Base64 Goes here
                            a.download = `Report.pdf`; //File name Here
                            a.click(); //Downloaded file
                        }
                    }}
                >
                    Download PDF
                </Button>
                <Button
                    size={'small'}
                    type={'primary'}
                    onClick={async () => {
                        const reportHtml = document.getElementById('report-result')
                        const res = await ApiService.Report.DownloadWord(`<html><head></head><body style="font-family: Calibri">${reportHtml.innerHTML}</body></html>`)

                        if(res.success) {
                            const base64data = res.data;
                            var a = document.createElement("a"); //Create <a>
                            a.href = 'data:application/text;base64,'+base64data; //Image Base64 Goes here
                            a.download = `Report.docx`; //File name Here
                            a.click(); //Downloaded file
                        }
                    }}
                >
                    Download Word
                </Button>
                <Button
                    size={'small'}
                    type={'primary'}
                    onClick={async () => {
                        const elTable = document.getElementById('report-result')

                        let range, sel;

                        if (document.createRange && window.getSelection) {
                            elTable.style.fontFamily = "Calibri";
                            range = document.createRange();
                            sel = window.getSelection();
                            // unselect any element in the page
                            sel.removeAllRanges();

                            try {
                                range.selectNodeContents(elTable);
                                sel.addRange(range);
                            } catch (e) {
                                range.selectNode(elTable);
                                sel.addRange(range);
                            }

                            document.execCommand('copy');

                            notification.success({
                                message: 'Result Copied!'
                            })
                        }

                        sel.removeAllRanges();
                    }}
                >
                    Copy
                </Button>
            </div>
            <b style={{color: 'red'}}>Missing Keys:</b> {Array.from(new Set(misMessages.keys)).map(m => m).join(', ')}
            <br/>
            <b style={{color: 'red'}}>Missing Codes:</b> {Array.from(new Set(misMessages.codes)).map(m => m).join(', ')}
            <br/>
            <div id={'report-result'}>
                {errors}
            </div>
        </>
    )
}